export const sampleConfig = {
  "settings": {
    "PaceAhead": 1,
    "AdrAhead": 1,
    "HealthyTightenFcst": 0.9,
    "AnyTightenFcst": 0.95,
    "PromoDesired": 0.1,
    "PromoDeep": 0.15,
    "PromoDeepPace": 0.85,
    "PromoMinDisc": 0.05,
    "CapStep": 0.05,
    "PromoLastMinDays": 7,
    "PromoMemberDays": 45,
    "EarlyBookLead": 30,
    "DefaultChannel": "Brand.com",
    "MinSample": 15,
    "MinDaysLive": 14,
    "ScaleROI": 1,
    "ScaleIncr": 0.4,
    "FixIncr": 0.15,
    "H_ROI": 40,
    "H_Incr": 25,
    "H_Leak": 20,
    "H_Target": 15
  },
  "hurdleTiers": [
    {
      "minForecast": 0,
      "hurdlePct": 0.55
    },
    {
      "minForecast": 0.7,
      "hurdlePct": 0.62
    },
    {
      "minForecast": 0.8,
      "hurdlePct": 0.7
    },
    {
      "minForecast": 0.85,
      "hurdlePct": 0.76
    },
    {
      "minForecast": 0.9,
      "hurdlePct": 0.82
    },
    {
      "minForecast": 0.95,
      "hurdlePct": 0.87
    }
  ],
  "channels": [
    {
      "name": "Brand.com",
      "dataKey": "Brand.com",
      "commission": 0,
      "direct": true
    },
    {
      "name": "Booking.com",
      "dataKey": "Booking.com",
      "commission": 0.18,
      "direct": false
    },
    {
      "name": "Expedia",
      "dataKey": "Expedia",
      "commission": 0.18,
      "direct": false
    }
  ],
  "promotionNames": [
    {
      "owner": "Brand.com",
      "lastMinute": "Last-minute offer to email and app audience",
      "memberOnly": "Loyalty member rate",
      "earlyBooker": "Advance purchase offer",
      "valueAdd": "Stay longer and save, breakfast included"
    },
    {
      "owner": "Booking.com",
      "lastMinute": "Last-minute deal",
      "memberOnly": "Genius member discount",
      "earlyBooker": "Early booker deal",
      "valueAdd": "Visibility boost with breakfast-included rate"
    },
    {
      "owner": "Expedia",
      "lastMinute": "Same-day and last-minute deal",
      "memberOnly": "Member Only Deal",
      "earlyBooker": "Early booking discount",
      "valueAdd": "Visibility boost with package rate"
    }
  ],
  "verdicts": [
    {
      "verdict": "Pre-launch",
      "nextStep": "Clear leak nights before launch"
    },
    {
      "verdict": "Paused",
      "nextStep": "No action"
    },
    {
      "verdict": "Too early",
      "nextStep": "Keep running; re-check when the sample is large enough"
    },
    {
      "verdict": "Scale",
      "nextStep": "Extend dates or widen the audience"
    },
    {
      "verdict": "Keep",
      "nextStep": "Keep running as is"
    },
    {
      "verdict": "Fix",
      "nextStep": "Reduce the discount or tighten fences"
    },
    {
      "verdict": "Stop",
      "nextStep": "End the promotion"
    }
  ],
  "leakRules": [
    {
      "code": "L1",
      "action": "Exclude the night"
    },
    {
      "code": "L2",
      "action": "Cap discount at the largest 5% step that clears the hurdle, else exclude"
    },
    {
      "code": "L3",
      "action": "Turn off stacking or lower one discount"
    },
    {
      "code": "L4",
      "action": "Informational: match on Brand.com or fence"
    }
  ]
};
export default sampleConfig;
